import { Observable } from "rxjs";

export abstract class AbStepAssembleia {
  abstract qtdFinalizadas: number;
  abstract mostrarConfgGerais: boolean;
  abstract assembleia;
  abstract getResultadoCompleted(): number;
  abstract observableCompleted(): Observable<boolean>;
  abstract setResultadoCompleted(): Observable<any>;
  abstract setVoltarResultadoCompleted(): Observable<any>;
  abstract reiniciarContagem();
  abstract terminarContagem();
}